export default customElements.define('w-callout', class Callout extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-callout';
        const config = {
            styleSelector,
            templateHTML: /*html*/`
            <div class="${styleSelector}__container" data-root>
                <div class="${styleSelector}__content">
                    <w-icon class="${styleSelector}__icon" size="150" data-callout-icon></w-icon>
                    <div class="u-text__line-height--compensate-for-center" data-child-root></div>
                </div>
            </div>`,
            hasChildren: true,
            cacheDom: [
                'data-callout-icon'
            ]
        };

        super(config);
    }

    static typeIconVariantMap = {
        [wealthify.enumsLocal.states.Danger]: 'danger-outlined',
        [wealthify.enumsLocal.states.Warning]: 'warning-outlined',
        [wealthify.enumsLocal.states.Success]: 'success-outlined',
        [wealthify.enumsLocal.states.Info]: 'info-circle',
    }

    static get observedProps () {
        return [
            new wealthify.Prop('full-width', {
                default: true,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('size', {
                default: wealthify.enumsLocal.sizes.Medium,
                type: wealthify.propTypes.ArrayItem(Object.values(wealthify.enumsLocal.sizes))
            }),
            new wealthify.Prop('variant', {
                default: 'info',
                type: wealthify.propTypes.ArrayItem(Object.values(wealthify.enumsLocal.states))
            })
        ];
    }

    get propCallbacks () {
        return {
            fullWidth: () => {
                this.dom.root.style.width = this.fullWidth ? '' : 'fit-content';
            },
            size: () => {
                Object.keys(wealthify.enumsLocal.sizes).forEach(size => this.classList.remove(`${this.styleSelector}--size-${size}`));
                this.classList.add(`${this.styleSelector}--size-${this.size}`);
            },
            variant: () => {  
                Object.keys(wealthify.enumsLocal.states).forEach(variant => this.classList.remove(`${this.styleSelector}--variant-${variant}`));
                this.classList.add(`${this.styleSelector}--variant-${this.variant}`);

                this.dom.calloutIcon.type = this.constructor.typeIconVariantMap[this.variant];
            }
        };
    }
});